// Shared money formatting (DS1.1). One place, so every money surface renders identically.
// TR groups with dots — ₺2.480; EN keeps its own grouping (2,480). DISPLAY-ONLY: it formats
// a server-owned figure (a number or a decimal string), it never computes or rounds price
// as logic — `maximumFractionDigits: 0` is a display choice for whole-lira premiums.
export interface CurrencyOptions {
  /** ISO 4217 code; defaults to TRY. */
  currency?: string;
  /** Grouping/locale; defaults to Turkish (dot thousands). */
  locale?: "tr" | "en";
  maximumFractionDigits?: number;
}

export function formatCurrency(amount: number | string, options: CurrencyOptions = {}): string {
  const { currency = "TRY", locale = "tr", maximumFractionDigits = 0 } = options;
  const intlLocale = locale === "en" ? "en-US" : "tr-TR";
  const n = typeof amount === "string" ? Number(amount) : amount;
  if (!Number.isFinite(n)) return `${amount} ${currency}`;
  try {
    return new Intl.NumberFormat(intlLocale, {
      style: "currency",
      currency,
      maximumFractionDigits,
    }).format(n);
  } catch {
    // An unknown/odd currency code → group the number and append the code rather than throw.
    return `${Math.round(n).toLocaleString(intlLocale)} ${currency}`;
  }
}
